<template>
  <div>
    <!-- <div class="container mb-5"> -->
    <div class="row">
      <div class="col-12">

        <!-- <form id="filter"> -->
        <span
          style="visibility: hidden;display:none">{{defaultvalues}}{{ff_fancount}}{{ff_ticks}}{{defaults_old}}</span>
        <div class="bg-gray-30 rounded mx-0 p-3 mb-3" v-if="filters.length>0">
          <div class="row">
            <div class="col-12">
              <p><a class="text-primary font-weight-normal" data-toggle="collapse" href="#collapseGlobal"><span
                    aria-hidden="true">
                    <svg class="icon mr-2 py-1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.filter"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg></span>{{ __('lang.filter.general.text')}}</a></p>
            </div>
          </div>
          <div class="collapse" id="collapseGlobal">
            <div class="row row-cols-2 row-cols-md-4 mb-3">
              <div class="col mb-3">
                <h6 class="small font-weight-bold">{{ __('lang.categories_head')}}
                  <!-- Typenfilter -->
                </h6>
                <!-- <h6 class="small font-weight-bold">Wenn Produkt keiner Kategorie zugeordnet ist, soll angezeigt werden oder nicht?</h6> -->
                <!--  <multiselect
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        v-model="value"
                        :options="options"
                        :multiple="true"
                        track-by="library"
                        :custom-label="customLabel"
                        :close-on-select="false"
                        @select=onSelect($event)
                        @remove=onRemove($event)
                        placeholder="Bitte auswählen"
                        >
                        <span class="checkbox-label" slot="option" slot-scope="scope" @click.self="select(scope.option)">
                          <input class="test" type="checkbox" v-model="scope.option.checked" @focus.prevent :key="scope.option.library"/>
                          {{ scope.option.library }}
                        </span>

                      </multiselect>
                    -->
                <!-- <div class="dropdown">
                      <button class="btn btn-block btn-white border font-weight-light dropdown-toggle" data-toggle="dropdown">
                        {{ __('lang.filter.category_ddlb.change')}}
                      </button>
                      <div class="dropdown-menu px-3 mt-0 w-100 border-gray-40 keep-open" ref="vuemodal">
                        <div class="col-2" v-for="(c, cIndex) in uniquecats">
                          <div class="col-2" v-for="(cd, cdIndex) in c.description_short">
                            <b-form-checkbox class="custom-control custom-checkbox" :id="'category-'+c.id"
                              v-model="selectedvalues['category'][cIndex]" name="category" :value="c.id">
                              {{cd}}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                    </div> -->

                  <!--   bevor un-/select all
                  <b-nav>
                     <b-nav-item-dropdown id="cat_ddlb" :text="__('lang.filter.category_ddlb.change')"
                      extra-toggle-classes="nav-link-custom" center
                      class="btn btn-block btn-white border font-weight-light">
                      <b-form-checkbox v-for="(field, index) in uniquecats" v-bind:key="index"
                        v-model="selectedvalues['category'][index]" :value="field.id" class="ml-2"><span
                          v-for="(cd, cdIndex) in field.description_short">{{cd}} ({{ff_fancount['category'][field.id]}})</span></b-form-checkbox>
                    </b-nav-item-dropdown>
                  </b-nav>
                  -->

              <b-nav>
                <!-- pills -->
                <b-nav-item-dropdown  id="cat_ddlb" :text="__('lang.filter.category_ddlb.change')"
                    extra-toggle-classes="nav-link-custom" center
                    class="btn btn-block btn-white border font-weight-light">
                  <b-form-group>
                    <template #label>
                      <b-form-checkbox v-model="allSelected" :indeterminate="indeterminate" @change="toggleAll" class="ml-1">
                        {{ allSelected? __('lang.btn.unselect_all') : __('lang.btn.select_all') }}
                      </b-form-checkbox>
                    </template>
                    <template>
                        <b-form-checkbox v-for="(field, index) in uniquecats" v-bind:key="index" v-model="selectedvalues['category'][index]"
                          :value="field.id" class="ml-2"><span v-for="(cd, cdIndex) in field.description_short">{{cd}}
                            ({{ff_fancount['category'][field.id]}})</span>
                        </b-form-checkbox>
                    </template>
                  </b-form-group>


                </b-nav-item-dropdown>
              </b-nav>



              </div>
              <div class="col mb-3"
                v-if="filters.filter(ffgroup => ffgroup.filtergroup==1 && ffgroup.ffType==='checkbox').length>0">
                <h6 class="small font-weight-bold">{{ __('lang.filter.options.text')}}</h6>
                <span
                  v-for="(ff, ffIndex) in filters.filter(ffgroup => ffgroup.filtergroup==1 && ffgroup.ffType==='checkbox')"
                  :key="ff.id">
                  <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                    <b-form-checkbox class="custom-control custom-checkbox" :id="ff.ffKey+'-'+ffoptIndex"
                      v-model="selectedvalues[ff.ffKey]" :name="ff.ffKey" :value="ffoptValue">
                      {{ __('lang.'+ ff.ffKey)}}<span class="text-gray-60">
                        ({{ff_fancount[ff.ffKey][ffoptName]}})</span>
                    </b-form-checkbox>
                  </span>
                </span>
              </div>
              <div class="col mb-3"
                v-for="(ff, ffIndex) in filters.filter(ffgroup => ffgroup.filtergroup==1 && ffgroup.ffType!=='checkbox')"
                :key="ff.id">


                <h6 class="small font-weight-bold">{{ __('lang.'+ff.ffKey)}}
                  <span v-if="ff.ffKey=='max_rpm'" v-b-tooltip.hover :title="tooltip_infobtn_max">
                    <!--   <span data-toggle="tooltip" title="Diese Werte gelten für den gewählten Betriebspunkt"> -->
                    <svg class="icon pb-1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </span>
                </h6>


                <div v-if="ff.ffType==='radiogroup'">
                  <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                    <b-form-radio :id="ff.ffKey+'-'+ffoptIndex" :name="ff.ffKey" :value="ffoptName" style="z-index:0;"
                      class="custom-control custom-radio" v-model="selectedvalues[ff.ffKey]"
                      @click.native="setradio(ff.ffKey,selectedvalues[ff.ffKey])">
                      <!-- $event.target.value -->
                      {{ __('lang.'+ ffoptValue)}}<span class="text-gray-60"> ({{ffoptValue=='all'? fancount :
                      ff_fancount[ff.ffKey][ffoptValue]}})</span>
                    </b-form-radio>
                  </span>
                </div>
                <div v-else-if="ff.ffType==='radio'">
                  <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                    <b-form-radio :id="ff.ffKey+'-'+ffoptIndex" :name="ff.ffKey" :value="ffoptName" style="z-index:0;"
                      class="custom-control custom-radio" v-model="selectedvalues[ff.ffKey]"
                      @click.native="setradio(ff.ffKey,selectedvalues[ff.ffKey])">
                      <!-- $event.target.value -->
                      {{ __('lang.'+ ffoptValue)}}<span class="text-gray-60"> ({{ffoptValue=='all'? fancount :
                      ff_fancount[ff.ffKey][ffoptValue]}})</span>
                    </b-form-radio>
                  </span>
                </div>

                <div v-else-if="ff.ffType==='checkboxgroup'">

                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group :id="'checkbox-group-'+ff.ffKey" v-model="selectedvalues[ff.ffKey]"
                      :aria-describedby="ariaDescribedby" :name="ff.ffKey" stacked>
                      <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                        <b-form-checkbox class="custom-control custom-checkbox" :value="ffoptName">
                          {{ __('lang.'+ ffoptName)}}<span class="text-gray-60"> ({{ffoptName=='all'? fancount :
                          ff_fancount[ff.ffKey][ffoptName]}})</span>
                        </b-form-checkbox>
                      </span>
                    </b-form-checkbox-group>
                  </b-form-group>

                </div>
                <div v-else-if="ff.ffType==='checkbox'">
                  <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                    <b-form-checkbox class="custom-control custom-checkbox" :id="ff.ffKey+'-'+ffoptIndex"
                      v-model="selectedvalues[ff.ffKey]" :name="ff.ffKey" :value="ffoptValue">
                      {{ __('lang.'+ ff.ffKey)}}<span class="text-gray-60">
                        ({{ff_fancount[ff.ffKey][ffoptName]}})</span>
                    </b-form-checkbox>
                  </span>
                </div>
                <div v-else-if="ff.ffType==='select'">
                  <b-form-select v-model="selectedvalues[ff.ffKey]" :id="ff.ffKey" :name="ff.ffKey"
                    class="custom-control custom-select">
                    <option v-for="(selectOption, indexOpt) in JSON.parse(ff.ffOptvalues)" :key="indexOpt"
                      :value="selectOption">
                      {{ parseFloat(selectOption)>0 ? parseFloat(selectOption) : __('lang.'+ selectOption)}}
                    </option>
                  </b-form-select>
                </div>
                <div v-else-if="ff.ffType==='range'" class="form-group pt-2 px-2">
                  <!-- <input class="drehzahl" data-provide="slider" data-slider-ticks="[750, 1000, 1500, 3000, 3800]" data-slider-ticks-labels="[750, 1000, 1500, 3000, 3800]" data-slider-ticks-positions="[0, 25, 50, 75, 100]" data-slider-ticks-snap-bounds="200" data-slider-value="[1000,3000]" data-slider-tooltip="hide"> -->
                  <!-- <b-form-slider :class="ff.ffClass" :ref="ff.ffKey" v-model="selectedvalues[ff.ffKey]" :min="ff.ffMin"
                          :max="ff.ffMax" :value="ff.ffMax" :step="1" tooltip="show">
                        </b-form-slider> -->
                  <span class="range-slider-minvalue">{{ticksconfig[ff.ffKey].min}}</span>
                  <b-form-slider :class="ff.ffClass" :ref="ff.ffKey" v-model="selectedvalues[ff.ffKey]" :range="true"
                    :value="ticksconfig[ff.ffKey].value" :min="ticksconfig[ff.ffKey].min"
                    :max="ticksconfig[ff.ffKey].max" :tooltip="ticksconfig[ff.ffKey].tooltip"
                    :tooltip_position="ticksconfig[ff.ffKey].tooltip_position">
                  </b-form-slider>
                  <span class="range-slider-maxvalue">{{ticksconfig[ff.ffKey].max}}</span>
                  <div class="mt-2 text-center">{{selectedvalues[ff.ffKey][0] + ' - '+ selectedvalues[ff.ffKey][1]}}
                    <span class="text-gray-60">
                      ({{ff_fancount[ff.ffKey][ff.ffKey]}})</span>
                  </div>
                </div>
                <div v-else-if="ff.ffType==='rangetick'" class="form-group pt-2 px-2">
                  <b-form-slider :class="ff.ffClass" :ref="ff.ffKey" v-model="selectedvalues[ff.ffKey]" :range="true"
                    :ticks="ff_ticks[ff.ffKey]" :ticks-labels="ticksconfig[ff.ffKey].labels"
                    :value="ticksconfig[ff.ffKey].value" :min="ticksconfig[ff.ffKey].min"
                    :max="ticksconfig[ff.ffKey].max" :ticks-positions="ticksconfig[ff.ffKey].pos"
                    :lock-to-ticks="ticksconfig[ff.ffKey].lock" :tooltip="ticksconfig[ff.ffKey].tooltip"
                    ticks-tooltip="false" :tooltip-position="ticksconfig[ff.ffKey].tooltip_position"></b-form-slider>
                  <!--
                          :formatter="tt_format"
                          scale="linear"
                        -->
                  {{selectedvalues[ff.ffKey][0] + ' - ' + selectedvalues[ff.ffKey][1]}}


                </div>
                <div v-else>
                  <b-form-input class="custom-control custom-input" :id="ff.ffKey+'-'+ffIndex" :name="ff.ffKey"
                    v-model="selectedvalues[ff.ffKey]" :placeholder="__('lang.'+ff.ffKey)"></b-form-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="filters.filter(ffgroup => ffgroup.filtergroup==2).length">
            <div class="col-12">
              <p class="mb-0"><a class="text-primary font-weight-normal" data-toggle="collapse"
                  href="#collapseDimensions"><span aria-hidden="true">
                    <svg class="icon mr-2 py-1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.filter"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg></span>{{ __('lang.filter.dimension.text')}}</a></p>
            </div>

          </div>
          <div class="collapse" id="collapseDimensions">
            <div class="form-group col-12 col-md-6 mb-0">
              <button class="btn btn-sm" style="font-size:0.75rem" type="reset" @click.prevent="unsetDimension">
                <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{ __('lang.btn.op.reset')}}
              </button>
            </div>

            <div class="row row-cols-2 row-cols-md-4 mt-3">
              <div class="col-12 col-md-3" v-for="(ff, ffIndex) in filters.filter(ffgroup => ffgroup.filtergroup==2)"
                :key="ff.id">
                <b-form-radio v-model="dimension.selection" name="dimensionsfilter" :value="ff.ffKey">
                  <h6 class="small font-weight-bold">{{ __('lang.'+ff.ffKey)}}</h6>
                </b-form-radio>
                <div v-if="ff.ffType==='radio'">
                  <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                    <b-form-radio :id="ff.ffKey+'-'+ffoptIndex" :name="ff.ffKey" :value="ffoptName" style="z-index:0;"
                      class="custom-control custom-radio" v-model="selectedvalues[ff.ffKey]">
                      {{ __('lang.'+ ffoptValue)}}<span class="text-gray-60">({{ffoptValue=='all'? fancount :
                      ff_fancount[ff.ffKey][ffoptValue]}})</span>
                    </b-form-radio>
                  </span>
                </div>
                <div v-else-if="ff.ffType==='checkbox'">
                  <span v-for="(ffoptValue, ffoptName, ffoptIndex) in JSON.parse(ff.ffOptvalues)">
                    <b-form-checkbox class="custom-control custom-checkbox" :id="ff.ffKey+'-'+ffoptIndex"
                      v-model="selectedvalues[ff.ffKey]" :name="ff.ffKey" :value="ffoptValue">
                      {{ __('lang.'+ ff.ffKey)}}<span class="text-gray-60">({{ff_fancount[ff.ffKey][ffoptName]}})</span>
                    </b-form-checkbox>
                  </span>
                </div>
                <div v-else-if="ff.ffType==='select'">
                  <b-form-select v-model="selectedvalues[ff.ffKey]" :id="ff.ffKey" :name="ff.ffKey"
                    class="custom-control custom-select">
                    <option v-for="(selectOption, indexOpt) in JSON.parse(ff.ffOptvalues)" :key="indexOpt"
                      :value="selectOption">
                      {{ parseFloat(selectOption)>0 ? parseFloat(selectOption) : __('lang.'+ selectOption)}}
                    </option>
                  </b-form-select>
                </div>
                <div v-else-if="ff.ffType==='range'" class="form-group pt-2 px-2" @click="setradiodimension(ff.ffKey)">
                  <!-- <input class="drehzahl" data-provide="slider" data-slider-ticks="[750, 1000, 1500, 3000, 3800]" data-slider-ticks-labels="[750, 1000, 1500, 3000, 3800]" data-slider-ticks-positions="[0, 25, 50, 75, 100]" data-slider-ticks-snap-bounds="200" data-slider-value="[1000,3000]" data-slider-tooltip="hide"> -->
                  <!-- <b-form-slider :class="ff.ffClass" :ref="ff.ffKey" v-model="selectedvalues[ff.ffKey]" :min="ff.ffMin"
                        :max="ff.ffMax" :value="ff.ffMax" :step="1" tooltip="show">
                      </b-form-slider> -->

                  <span class="range-slider-minvalue">{{ticksconfig[ff.ffKey].min}}</span>
                  <b-form-slider :class="ff.ffClass" :ref="ff.ffKey" v-model="selectedvalues[ff.ffKey]"
                    @slide-stop="slideStop(ff.ffKey)" :range="true" :value="ticksconfig[ff.ffKey].value"
                    :min="ticksconfig[ff.ffKey].min" :max="ticksconfig[ff.ffKey].max"
                    :tooltip="ticksconfig[ff.ffKey].tooltip" :tooltip_position="ticksconfig[ff.ffKey].tooltip_position"
                    :trigger-change-event="triggerChangeEvent" :trigger-slide-event="triggerSlideEvent"
                    :disabled="dimensiondisabled[ff.ffKey]">
                    <!--this.dimension.selection===key?this.selectedvalues[ff.ffKey]:this.defaults_old[ff.ffKey]  :disabled="dimensiondisabled[ff.ffKey]" -->
                  </b-form-slider><span class="range-slider-maxvalue">{{ticksconfig[ff.ffKey].max}}</span>
                  <div class="mt-2 text-center">
                    {{(selectedvalues[ff.ffKey][0] == undefined ? defaults_old[ff.ffKey][0]:selectedvalues[ff.ffKey][0])
                    + ' - '+ (selectedvalues[ff.ffKey][1] == undefined ? defaults_old[ff.ffKey][1] :
                    selectedvalues[ff.ffKey][1])}} <span class="text-gray-60">
                      ({{ff_fancount[ff.ffKey][ff.ffKey]}})</span>
                  </div>
                </div>
                <div v-else-if="ff.ffType==='rangetick'" class="form-group pt-2 px-2">

                  <b-form-slider :class="ff.ffClass" :ref="ff.ffKey" v-model="selectedvalues[ff.ffKey]" :range="true"
                    :ticks="ff_ticks[ff.ffKey]" :ticks-labels="ticksconfig[ff.ffKey].labels"
                    :value="ticksconfig[ff.ffKey].value" :min="ticksconfig[ff.ffKey].min"
                    :max="ticksconfig[ff.ffKey].max" :ticks-positions="ticksconfig[ff.ffKey].pos"
                    :lock-to-ticks="ticksconfig[ff.ffKey].lock" :tooltip="ticksconfig[ff.ffKey].tooltip"
                    :ticks-tooltip="false" :tooltip-position="ticksconfig[ff.ffKey].tooltip_position"></b-form-slider>
                  <!--
                        data-slider-ticks-snap-bounds="200" je grösser desto genauer
                        :formatter="tt_format"
                        scale="linear"
                      -->
                  <div class="mt-2 text-center" v-if="selectedvalues[ff.ffKey][0]>=0 && selectedvalues[ff.ffKey][1]>0">
                    {{selectedvalues[ff.ffKey][0] + ' - ' + selectedvalues[ff.ffKey][1]}}
                  </div>

                </div>
                <div v-else-if="ff.ffType==='ddlbcheckboxgroup'" @click="setradiodimension(ff.ffKey)">
                  <b-nav>
                    <b-nav-item-dropdown :id="'ddlb-cb-'+ff.ffKey" :text="__('lang.filter.category_ddlb.change')"
                      extra-toggle-classes="nav-link-custom" center
                      class="btn btn-block btn-white border font-weight-light">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group :id="'ddlbcheckboxgroup-'+ff.ffKey" v-model="selectedvalues[ff.ffKey]"
                          :aria-describedby="ariaDescribedby" :name="ff.ffKey" stacked class="pl-2">
                          <span v-for="(fieldvalue,index) in uniqueduct_dimension">
                            <b-form-checkbox class="custom-control custom-checkbox" :value="fieldvalue"
                              :disabled="dimensiondisabled[ff.ffKey]">
                              {{fieldvalue}} <span class="text-gray-60">
                                ({{ ff_fancount[ff.ffKey][fieldvalue] > 0 ? ff_fancount[ff.ffKey][fieldvalue]
                                :0}})</span>
                            </b-form-checkbox>
                          </span>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </b-nav-item-dropdown>
                  </b-nav>
                </div>
                <div v-else>
                  <b-form-input class="custom-control custom-input" :id="ff.ffKey+'-'+ffIndex" :name="ff.ffKey"
                    v-model="selectedvalues[ff.ffKey]" :placeholder="__('lang.'+ff.ffKey)"></b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  </form> -->
        <p class="mb-4">
          <!--  <span class="mr-3" v-if="fancount>0 || accessoriescount>0">
              {{__('lang.resultlist.searchresult')}} :
              <span v-if="fancount>0">
                {{ __('lang.resultlist.header_fans')}} : {{fancount}} {{__('lang.resultlist.model')}}
                <span v-if="filters.length>0">{{__('lang.resultlist.filterresult')}}:{{resultlist.filter(row => row.flag_fan === 1).length}}</span>
              </span>
              <span v-if="accessoriescount>0">
                {{ __('lang.global.product.tabs.accessories')}} : {{accessoriescount}} {{__('lang.resultlist.model')}}
              </span>
            </span>
            <span class="mr-3" v-else > 0 </span>  -->
          <span class="mr-3" v-if="filters.length>0"><a class="font-weight-normal" role="button"
              @click.prevent="setFilterDefaults">{{__('lang.btn.filterreset')}}</a></span>
          <!--   <span class="ml-3"><a class="btn btn-sm border btn-outline-gray-70" role="button" title="Filter löschen" onclick="$(this).hide();">
                  <svg class="icon icon-xxs mr-1">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>Spannung 230/1/50</a>
            </span>
            <span class="ml-3"><a class="btn btn-sm border btn-outline-gray-70" role="button" title="Filter löschen" onclick="$(this).hide();">
                  <svg class="icon icon-xxs mr-1">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>Temperaturklasse F300</a>
            </span> -->
        </p>
        <!-- tabs: -->
        <ul class="nav nav-tabs mb-3" role="tablist">
          <li class="nav-item ml-3 ml-md-0" role="presentation">
            <a :class="fancount>0?'nav-link h5 active':'nav-link h5 disabled'" id="products-nav-tab" data-toggle="tab"
              href="#products-tab-pane" role="tab" aria-controls="products-tab-pane" aria-selected="true">
              {{ __('lang.resultlist.header_fans')}}
              <div class="badge badge-gray-30 text-gray-60 ml-1">
                <span v-if="fancount>0">{{resultlist.filter(row => row.flag_fan === 1).length}} / {{fancount}} </span>
                <span v-else> 0 </span> <!-- {{__('lang.message.noproducts')}} -->
              </div>
            </a>
          </li>
          <li  v-show="search_flag != 'op'" class="nav-item ml-md-3" role="presentation">
            <a :class="accessoriescount>0 ? (fancount>0 ? 'nav-link h5':'nav-link h5 active') : 'nav-link h5 disabled'"
              id="accessories-nav-tab" data-toggle="tab" href="#accessories-tab-pane" role="tab"
              aria-controls="accessories-tab-pane" aria-selected="false">
              {{ __('lang.global.product.tabs.accessories')}}
              <div class="badge badge-gray-30 text-gray-60 ml-1">
                <span v-if="accessoriescount>0"> {{accessoriescount}} </span>
                <span v-else> 0 </span> <!-- {{__('lang.message.noproducts')}} -->
              </div>

            </a>
          </li>
        </ul>
        <!-- :tabs -->
        <div class="tab-content">
          <!-- fans: sticky-header="50vh" Adjust the value according to the percentage viewport height occupied by the table. -->
            <!-- :class="fancount>0 ? 'tab-pane active':'tab-pane'"-->
            <div v-show = "fancount==0 && accessoriescount==0"  class="text-center p-5 bg-gray-20">{{__('lang.resultlist.nodata')}}</div>
            <div :class="fancount>0 ? 'tab-pane active':'tab-pane'" id="products-tab-pane">
            <!-- <b-table sticky-header="500px" class="table table-borderless table-striped table-responsive-md mb-6" striped
              borderless responsive="md" details-td-class="p-0" :items="resultlist.filter(row => row.flag_fan === 1)"
              :fields="table_fields_fans" :sort-compare-options="{ numeric: true }" :sort-compare="sortOnTableColumn"
              sort-icon-left> -->



            <b-table class="table table-borderless table-striped table-responsive-md mb-6" striped borderless
              responsive="md" details-td-class="p-0" :items="resultlist.filter(row => row.flag_fan === 1)"
              :fields="table_fields_fans" :sort-compare-options="{ numeric: true }" :sort-compare="sortOnTableColumn"
            sort-icon-left sort-by="price"  show-empty>
               <template #empty="scope">
                    <div  class="text-center p-5">{{__('lang.resultlist.nodata')}}</div>
                </template>
              <template v-slot:head(volumeflow)="data">
                <span>{{ data.label}}
                  <span v-show="search_flag=='op'" v-b-tooltip.hover :title="tooltip_infobtn">
                    <!--   <span data-toggle="tooltip" title="Diese Werte gelten für den gewählten Betriebspunkt"> -->
                    <svg class="icon pb-1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </span>
                </span>
              </template>
              <template v-slot:head(pressure)="data">
                <div v-show="search_flag=='op'">
                  <span>{{ data.label}}
                    <span v-b-tooltip.hover :title="tooltip_infobtn">
                      <!--   <span data-toggle="tooltip" title="Diese Werte gelten für den gewählten Betriebspunkt"> -->
                      <svg class="icon pb-1">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                          xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                      </svg>
                    </span>
                  </span>
                </div>
              </template>
              <template v-slot:head(rpm)="data">
                <span>{{ data.label}}
                  <span v-show="search_flag=='op'" v-b-tooltip.hover :title="tooltip_infobtn_max">
                    <!--   <span data-toggle="tooltip" title="Diese Werte gelten für den gewählten Betriebspunkt"> -->
                    <svg class="icon pb-1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </span>
                </span>
              </template>
              <template v-slot:head(elpower)="data">
                <span>{{ data.label}}
                  <span v-show="search_flag=='op'" v-b-tooltip.hover :title="tooltip_infobtn_max">
                    <!--   <span data-toggle="tooltip" title="Diese Werte gelten für den gewählten Betriebspunkt"> -->
                    <svg class="icon pb-1">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </span>
                </span>
              </template>
              <template v-slot:cell(ref_no)="{item}">
                <span v-if="item.state.toLowerCase()==='v'">{{item.ref_no + ' - ' + item.version}}</span>
                <span v-else>{{item.ref_no}}</span>
              </template>
             <!--  <template v-slot:cell(type)="typerow">
 -->
              <template #cell(type)="typerow">

                <div :id="'hoverBtnId_'+ typerow.item.id">
                  <b-button  variant="link" v-b-tooltip.hover class="text-left  pt-0 pb-0">
                    <span>
                      <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution,typerow.item) }"
                        class="text-primary" role="button" target="_blank">
                        <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution, typerow.item)" role="link">{{ typerow.item.type }}</span>

                        <span class="small"  v-if="typerow.item.execution == 1"><br>{{ __('lang.highcharts.blowout.bothsidesradial') }}</span>
                        <span class="small"  v-else-if="typerow.item.execution == 2"><br>{{ __('lang.highcharts.blowout.axial') }}</span>
                        <span class="small"  v-else-if="typerow.item.execution == 3"><br>{{ __('lang.highcharts.blowout.radial') }}</span>
                        <span class="small"  v-else></span>
                      </router-link>
                      </span>
                    <span class="small text-primary"
                          v-if="typerow.item.state.toLowerCase() == 'v'"><br>{{ __('lang.product.text.old') }}
                    </span>
                  </b-button>
                  <!-- <b-button  variant="link" v-b-tooltip.hover class="text-left">test </b-button> -->
                </div>
                <b-popover :target="'hoverBtnId_'+ typerow.item.id" triggers="hover" placement="auto"  custom-class="quickview">

                    <template v-slot:default>
                      <div class="media">
                          <div  v-for="(media, mediaIndex) in typerow.item.product_media.filter(item => item.media_type === 'image' && item.filename != '')">
                                <img class="img-fluid" :src="mediaserver_url + media.path + media.filename" />
                          </div>
                          <div><h6>{{ typerow.item.type }}</h6>
                            <p><span v-for="(desc, descIndex) in typerow.item.product_descriptions">
                                  <!-- <h5 class="mb-3">{{ desc.description_short }}</h5> -->
                                  <p>{{ getLongDesc(desc.description_long) }}</p>
                                </span>
                           </p>
                          </div>
                      </div>
                    </template>

                </b-popover>

              </template>
              <template v-slot:cell(volumeflow)="{ item }">
                <span
                  v-if="!item.volumeflow || item.volumeflow==0">{{item.max_volumeflow}}</span>
                <span v-else>{{ item.volumeflow }}</span>
              </template>
              <template v-slot:cell(elpower)="{ item }">
                <span>{{ parseFloat(Math.max(item.power1 / 1000, item.power2 / 1000).toFixed(5)) }}</span>
               <!--  <span v-if="!item.elpower || item.elpower==0">{{parseFloat(Math.max(item.power1/1000,item.power2/1000).toFixed(5))}}</span>
                <span v-else>{{parseFloat(item.elpower/1000).toFixed(2)}}</span> -->
              </template>
              <template v-slot:cell(rpm)="{ item }">
                <span>{{ Math.max(parseFloat(item.max_rpm, item.rpm1, item.rpm2)).toFixed(0)>0 ? Math.max(parseFloat(item.max_rpm, item.rpm1, item.rpm2)).toFixed(0):'-'}}</span>
                <!-- <span v-if="!item.rpm || parseFloat(item.rpm).toFixed(0) <= 0">-</span>
                <span v-else>{{ parseFloat(item.rpm).toFixed(0) }}</span>

                <span
                  v-if="!item.rpm || parseFloat(item.rpm).toFixed(0)==0">itemleer{{Math.max(item.max_rpm,item.rpm1,item.rpm2)}}</span> -->

              </template>
              <template v-slot:cell(pressure)="pressrow">
                <div v-show="search_flag=='op'">{{ pressrow.item.pressure }}</div>
              </template>

              <template v-slot:cell(dimension)="{item}">
                <span v-if="item.connect_diameter>0">{{item.connect_diameter}}</span>
                <span v-else-if="item.wheel_diameter>0">{{item.wheel_diameter}}</span>
                <span v-else-if="item.duct_dimension && item.duct_dimension!=''">{{item.duct_dimension}}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(shoppingcart)="{ item }">
                <div v-if="item.state=='A'" class="text-center">
                  <a class="text-primary" role="button" data-toggle="modal" data-target="#fullModal"
                    data-content="basket-add" @click="setCartItem(item)">
                    <svg class="icon icon-sm">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </a>
                </div>
              </template>
              <template #cell(info)="row">
                <div class="text-center">
                  <button role="button" @click="row.toggleDetails"
                    :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                    data-toggle="collapse">
                    <svg class="icon">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </button>
                </div>
              </template>
              <template #row-details="row">

                <div class="bg-white">

                  <div class="border-bottom">
                    <div class="container-fluid py-3">
                      <div class="row justify-content-center">
                        <div class="col-2"
                          v-for="(media, mediaIndex) in row.item.product_media.filter(item => item.media_type === 'image' && item.filename!='' )">
                          <img class="img-fluid" :src="mediaserver_url + media.path + media.filename" />
                        </div>
                        <div class="col-7">
                          <p class="mb-0">{{row.item.type}}</p>

                          <span v-for="(desc, descIndex) in row.item.product_descriptions" style="white-space: pre-line">
                            <h5 class="mb-3">{{desc.description_short}}</h5>
                            <p>{{desc.description_long}}</p>
                          </span>
                          <ul class="list-unstyled downloads">
                            <li class="mb-1">
                              <router-link
                                :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.version,1, row.item.execution,row.item)}"
                                class="text-primary font-weight-bold" role="button" target="_blank">
                                <span @click.prevent="opendetail(row.item.ref_no, row.item.version,1,row.item.execution,row.item)" role="link">
                                  <svg class="icon">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                  </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}</span>
                              </router-link>

                            </li>
                            <li class="mb-1"
                              v-for="(media, mediaIndex) in row.item.product_media.filter(item => item.media_type === 'datasheet' && item.filename!='')">
                              <a class="text-primary font-weight-bold"
                                :href="mediaserver_url + media.path + media.filename" target="_blank" role="button">
                                <svg class="icon">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>{{__('lang.global.product.downloads.datasheet')}}<span
                                  class="d-block small font-weight-light text-secondary pl-4">{{row.item.datasheet}}</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </template>
            </b-table>
          </div>
          <!-- :fans -->
          <!-- accessories: -->
          <div :class="accessoriescount>0 ? (fancount>0 ? 'tab-pane':'tab-pane active') : 'tab-pane'"
            id="accessories-tab-pane">
            <!-- <b-table sticky-header="500px" class="table table-borderless table-striped table-responsive-md mb-6" striped
              borderless responsive="md" details-td-class="p-0" :items="resultlist.filter(row => row.flag_fan === 2)"
              :fields="table_fields_accessories"> -->
            <b-table class="table table-borderless table-striped table-responsive-md mb-6" striped borderless
              responsive="md" details-td-class="p-0" :items="resultlist.filter(row => row.flag_fan === 2)"
              :fields="table_fields_accessories">
             <!--  <template v-slot:cell(type)="{item}">
                <span>
                  <router-link :to="{ name: 'productdetail', query: query_params(item.ref_no, item.version,0, item.execution)}"
                    class="text-primary" role="button" target="_blank">
                    <span @click.prevent="opendetail(item.ref_no, item.version,0)" role="link">{{item.type}}</span>
                  </router-link>
                </span><br>
                <span class="small text-primary"
                  v-if="item.state.toLowerCase()=='v'">{{__('lang.product.text.old')}}</span>
              </template>
               -->
            <template v-slot:cell(ref_no)="{item}">
                <span v-if="item.state.toLowerCase()==='v'">{{item.ref_no + ' - ' + item.version}}</span>
                <span v-else>{{item.ref_no}}</span>
            </template>
              <template #cell(type)="typerow">

                  <div :id="'hoverBtnId_' + typerow.item.id">
                    <b-button  variant="link" v-b-tooltip.hover class="text-left  pt-0 pb-0">
                      <span>
                        <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 0, typerow.item.execution,typerow.item) }"
                          class="text-primary" role="button" target="_blank">
                          <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution,typerow.item)" role="link">{{ typerow.item.type }}</span>
                        </router-link>
                      </span>
                      <span class="small text-primary"
                            v-if="typerow.item.state.toLowerCase() == 'v'"><br>{{ __('lang.product.text.old') }}
                      </span>
                    </b-button>
                    <!-- <b-button  variant="link" v-b-tooltip.hover class="text-left">test </b-button> -->
                  </div>
                  <b-popover :target="'hoverBtnId_' + typerow.item.id" triggers="hover" placement="auto"  custom-class="quickview">

                      <template v-slot:default>
                        <div class="media">
                            <div  v-for="(media, mediaIndex) in typerow.item.product_media.filter(item => item.media_type === 'image' && item.filename != '')">
                                  <img class="img-fluid" :src="mediaserver_url + media.path + media.filename" />
                            </div>
                            <div><h6>{{ typerow.item.type }}</h6>
                              <p><span v-for="(desc, descIndex) in typerow.item.product_descriptions">
                                    <!-- <h5 class="mb-3">{{ desc.description_short }}</h5> -->
                                    <p>{{ getLongDesc(desc.description_long) }}</p>
                                  </span>
                             </p>
                            </div>
                        </div>
                      </template>

                  </b-popover>

              </template>
              <template #cell(description_short)="description">
                  <span v-for="(desc, descIndex) in description.item.product_descriptions">
                    {{ desc.description_short }}
                  </span>
                </template>





              <template  v-slot:cell(prodgroup)="{ item }">
                    {{ item.prodgroup }}
              </template>

              <template v-slot:cell(shoppingcart)="{ item }">
                <div v-if="item.state=='A'"  class="text-center">
                  <a class="text-primary" role="button" data-toggle="modal" data-target="#fullModal"
                    data-content="basket-add" @click="setCartItem(item)">
                    <svg class="icon icon-sm">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                  </a>
                </div>
              </template>
              <template #cell(info)="row">
                <div class="text-center">
                  <button role="button" @click="row.toggleDetails"
                    :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'"
                    data-toggle="collapse">
                    <svg class="icon">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>
                  </button>
                </div>
              </template>
              <template #row-details="row">

                <div class="bg-white">

                  <div class="border-bottom">
                    <div class="container-fluid py-3">
                      <div class="row justify-content-center">
                        <div class="col-2"
                          v-for="(media, mediaIndex) in row.item.product_media.filter(item => item.media_type === 'image' && item.filename!='')">
                          <img class="img-fluid" :src="mediaserver_url + media.path + media.filename" />
                        </div>
                        <div class="col-7">
                          <p class="mb-0">{{row.item.type}}</p>
                          <span v-for="(desc, descIndex) in row.item.product_descriptions" style="white-space: pre-line">
                            <h5 class="mb-3">{{desc.description_short}}</h5>
                            <p>{{desc.description_long}}</p>
                          </span>
                          <ul class="list-unstyled downloads">
                            <li class="mb-1">
                              <router-link
                                :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.version,0, row.item.execution,row.item)}"
                                class="text-primary font-weight-bold" role="button" target="_blank">
                                <span @click.prevent="opendetail(row.item.ref_no, row.item.version,0,row.item.execution,row.item)" role="link">
                                  <svg class="icon">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                  </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}
                                </span>
                              </router-link>
                            </li>
                            <li class="mb-1"
                              v-for="(media, mediaIndex) in row.item.product_media.filter(item => item.media_type === 'datasheet' && item.filename!='')">
                              <a class="text-primary font-weight-bold"
                                :href="mediaserver_url + media.path + media.filename" target="_blank" role="button">
                                <svg class="icon">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>{{__('lang.global.product.downloads.datasheet')}}<span
                                  class="d-block small font-weight-light text-secondary pl-4">{{row.item.datasheet}}</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </template>
            </b-table>
          </div>
          <!-- :accessories -->
        </div>
      </div>
    </div>
    <!--  <div class="row">
          <div class="col-6 col-md-3"><a class="btn btn-white text-primary" @click="clearSession">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.reset')}}</a>
          </div>
      </div> -->

    <div class="row">
      <div class="col-12 col-md-3"><a class="btn btn-white text-primary" @click="gotostartpage">
          <svg class="icon">
            <use xlink:href="/assets/img/icon-sprite.svg#global.previous" xmlns:xlink="http://www.w3.org/1999/xlink">
            </use>
          </svg>{{__('lang.btn.reset.gotostartpage')}}</a>
      </div>
    </div>


    <!-- </div> -->
    <!-- Add to shoppingcart -->
    <div class="modal fade" id="fullModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content rounded-lg border-0 shadow-lg">
          <div class="modal-header justify-content-end border-0">
            <button class="close ml-auto mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close"
              id="closeModalAccessories">
              <span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg>
              </span>
            </button>
          </div>
          <div class="modal-body" width="300" height="300">
            <accessories ref="add_from_productlist" parentID="productlist" :parent_product="productlist_item">
            </accessories>
          </div>
          <div class="modal-footer justify-content-center border-0">
            <button class="btn btn-gray-50 text-white" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                </use>
              </svg>{{__('lang.btn.back')}}
            </button>
<!--            <a class="btn btn-primary border-0" @click.prevent="$refs.add_from_productlist.storeSelectedProducts()">
              <svg class="icon icon-sm">
                <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart-alternative"
                  xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg><span class="align-middle">{{__('lang.shoppingcart.add')}}</span>
            </a>-->
            <a class="btn btn-primary border-0"  @click.prevent="$refs.add_from_productlist.sendToFelderer">
              <svg class="icon icon-sm">
                <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart-alternative"
                  xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg><span class="align-middle">{{ __('lang.shoppingcart.pricecalculation') }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import operatingpointApi from './services/api/operatingpointAPI.js'
    //import productdataApi from './services/api/productdataAPI.js'
   // import productlistjumbotron  from './ProductListJumbotron'
    //import productlistfilter  from './ProductListFilter'
    import accessories from './Accessories'
    //import {EventBus}  from  './services/eventbus/event-bus'
    //import multiselect from 'vue-multiselect'


    export default {
       components: {
     //       productlistjumbotron,
      //      productlistfilter,
            accessories,
            //multiselect
        },
      computed: {
          search_flag:  function(){

            //return this.$store.state.shoppingcart.search_flag
           /* console.log('productlist $parent.search_flag')
            console.log(this.$parent.search_flag)*/
            return this.$parent.search_flag

          },
          table_fields_fans: {
              get () {
                return this.setFieldLabels(this.$store.state.operatingpoint.table_fields_fans)
              }
            },
          table_fields_accessories: {
            get() {
              return this.setFieldLabels(this.$store.state.operatingpoint.table_fields_accessories)
            }
          },
          units: {
            get() {
              return this.$store.state.operatingpoint.op.units
            }

          },
          fancount: function(){
              return this.$store.state.operatingpoint.resultlist_products.filter(product=> product.flag_fan === 1).length
            },
          accessoriescount: function () {
            return this.$store.state.operatingpoint.resultlist_products.filter(product => product.flag_fan === 2).length
          },
          filters: function () {
            var uniquefiltered = [];
            var uniquefiltered_cats = [];
            var prod_cats = []
            prod_cats=this.$store.state.operatingpoint.resultlist_categories

            //Get unique categories
            if (prod_cats && prod_cats.length > 0){

              prod_cats.filter(function (item) {
                var i = uniquefiltered_cats.findIndex(x => (x.id == item.id));
                if (i <= -1) {
                  uniquefiltered_cats.push(item);
                }
                return null;
              });
              this.uniquecats = uniquefiltered_cats
              //Get unique ff from all uniquecategories
              if (uniquefiltered_cats !== null) uniquefiltered_cats.forEach(function (cats) {
                cats.ffs.filter(function (item) {
                  var i = uniquefiltered.findIndex(x => (x.id == item.id));
                  if (i <= -1) {
                    uniquefiltered.push(item);
                  }
                  return null;
                });
              });

              //  uniquefiltered.sort((a, b) => a.filtergroupSort - b.filtergroupSort)
              uniquefiltered.sort((a, b) => a.sort - b.sort)
             /*  console.log('filters:')
              console.log(uniquefiltered) */
            }
            return uniquefiltered

          },
          defaultvalues: function () {
            return this.setFilterDefaults()

          },

          ff_fancount: function () {
            var arr = []
            var ff={}
            var fields = {}, fields_cat = {}, arr_cat =[]
            //var prodlist = this.$store.state.operatingpoint.resultlist_products
            var prodlist = this.resultlist.filter(row => row.flag_fan === 1)
            var selval = this.selectedvalues
            /*count for each product category:*/
            this.uniquecats.forEach(function (cat) {
              arr = prodlist.map(function (products) { return products['product_categories'] }).filter(function (k) {
                if (k != null) {
                 arr_cat = k.filter(item => item.category_id === cat.id);
                 return arr_cat.length > 0
                }
                else return false
              })
              fields_cat[cat.id] = arr.length


            })
            ff['category'] = fields_cat

            /*count for each another filter:*/
            this.filters.forEach(function (f) {
              fields = {}

              if (f.ffOptvalues !== null) {
                var obj = JSON.parse(f.ffOptvalues)
                for (let value of Object.keys(obj)) {
                  //arr = prodlist.map(function (products) { return products[f.ffKey] }).filter(k => k == obj[value])
                  arr = prodlist.map(function (products) { return products[f.ffKey] }).filter(function (k) {
                    // return k == obj[value]
                    if (k != null) {
                      var k_arr = k.toString().split(';')
                      return Array.isArray(k_arr) ? k_arr.includes(obj[value]) : k == obj[value]
                    }
                    else return false
                  });

                  fields[value] = arr.length
                }
              }
              else {
                if (f.ffType == 'rangetick' || f.ffType == 'range') {

                  arr = prodlist.map(function (products) { return products[f.ffKey] }).filter(function (k) {

                    if (k != null) {
                      return parseFloat(selval[f.ffKey][0]) <= parseFloat(k) && parseFloat(k) <= parseFloat(selval[f.ffKey][1])
                    }
                    else return false
                  });
                  fields[f.ffKey] = arr.length

                }
                else if (f.ffType == 'ddlbcheckboxgroup') {
                  if (selval[f.ffKey].length > 0){

                    arr = prodlist.map(function (products) { return products[f.ffKey] }).filter(function (k) {

                      if (k != null) {

                        return selval[f.ffKey].includes(k)
                      }
                      else return false
                    });
                  }
                  else {
                    arr = prodlist.map(function (products) { return products[f.ffKey] }).filter(function (k) {

                      if (k != null) {

                        return k.includes(selval[f.ffKey])
                      }
                      else return false
                    });

                  }



                  fields = arr.reduce((acc, val) => {
                    acc[val] = acc[val] === undefined ? 1 : acc[val] += 1;
                    return acc;
                  }, {});



                }
                else fields=null
              }
              /* console.log('fields:')
              console.log(fields) */
              ff[f.ffKey]=fields
            });

            //console.log('ff_fancount_new:')
            //console.log(ff)
            //this.ff_counter= ff
            return ff
          },
          ff_ticks: function () {
            var arr = []
            var ff_ticks = {}
            /*config for ticks:*/
            var tick_config = {}
            var pos = []
            var percent
            var prodlist = this.$store.state.operatingpoint.resultlist_products

            this.filters.forEach(function (f) {
              if(f.ffType=='rangetick'|| f.ffType == 'range'){
                arr = prodlist.map(function (products) { return products[f.ffKey] });
                var unique_arr = [...new Set(arr)]
                var unique_filtered_arr = unique_arr.filter(function (el) {
                  return el != null;
                });

                unique_filtered_arr.sort(function (a, b) {
                  return a - b;
                });
                ff_ticks[f.ffKey] = unique_filtered_arr

                pos = []
                //muss should be evenly distributed
                pos.unshift(0);
                for (var i =  2; i < unique_filtered_arr.length; i++) {
                  percent = i * Math.round(100 / unique_filtered_arr.length-1)
                  if(percent < 100) pos.push(percent)
                }
                pos.push(100);


                tick_config[f.ffKey]= {
                  min: isFinite(Math.min(...unique_filtered_arr)) ? Math.round(Math.min(...unique_filtered_arr)) : 0,
                  //min: f.ffType == 'range'? 0 : Math.min(...unique_filtered_arr),
                  max: isFinite(Math.max(...unique_filtered_arr)) ? Math.round(Math.max(...unique_filtered_arr)):0,
                  value: [Math.round(Math.min(...unique_filtered_arr)), Math.round(Math.max(...unique_filtered_arr))],
                 // value: [f.ffType == 'range'? 0 : Math.min(...unique_filtered_arr), Math.max(...unique_filtered_arr)],
                  labels: unique_filtered_arr,
                  pos: pos,
                  lock: true,
                  tooltip: 'hide',
                  tooltip_position: 'top'

                }
              }

            });
            this.ticksconfig= tick_config


           /*  console.log('tick_config:')
            console.log(tick_config) */
            return ff_ticks
          },
          session: {
              get () {
                return this.$store.state.user.session
              },
              set (value) {
                    this.$store.commit('user/updateSession', value)
                }
          },
          user: {
            get () {
              return this.$store.state.user.user
            },
            set (value) {
                  this.$store.commit('user/updateUser', value)
              }
          },
         /*  mediaData: function(){
            return this.$store.state.productdata.mediaData
          }, */
          selectedlocale:{
            get () {
              return this.$store.state.user.selectedlocale
            },
            set (value) {
                  this.$store.commit('user/updateSelectedlocale', value)
              }
          },
          tooltip_infobtn: function () {
            return this.__('lang.resulttable.headtooltip.calculatedvalues')
          },
          tooltip_infobtn_max: function () {
            return this.__('lang.resulttable.headtooltip.calculatedvalues_max')
          },
          op: {
            get() {
              return this.$store.state.operatingpoint.op;
            },
            set(value) {
              this.$store.commit('operatingpoint/updateop', value);
            }
          },

        },
        data() {
          return {
              /*
              value: [],
              options: [
                {	language: 'JavaScript', library: 'Vue.js', checked: false },
                { language: 'JavaScript', library: 'Vue-Multiselect', checked: false },
                { language: 'JavaScript', library: 'Vuelidate', checked: false }
              ],
               */


              resultlist:[],
              categorydata:[],
              cartitems:[],
             /*  media_dir: '/mediadata/', */
              min: 0,
              max: 2000,
              selectedvalues: {},
              //test:[],
              //ff_counter:{}
              //ff_ticks:[]
              ticksconfig: {},
              uniquecats:[],
              uniqueduct_dimension:[],
              dimension:{
                  selection: ''
              },
              defaults_old: [],
              defaults_dimension: [],

              dimensiondisabled:{'wheel_diameter' : true,
                                 'connect_diameter' : true,
                                 'duct_dimension' : true},


              triggerChangeEvent:true,
              triggerSlideEvent:true,

              productlist_item: {
                'id': null,
                'ref_no': null,
                'version': null,
                'execution': null,
                'type': null, 'flag_fan': null, 'state': null, 'prodgroup': null, 'max_angle': null,
                'weight': null, 'voltage': null,
                'max_rpm': null, 'speedcontrol_type': null, 'speedcontrol_type1': null,'speedcontrol_type2': null,'speedcontrol_type3': null,
                'lining': null, 'explosionproof': null, 'tempclass': null,
                'rpm1': null, 'rpm2': null, 'flc_uncontrolled1': null,
                'flc_uncontrolled2': null, 'factor_stc_uncontrolled': null,
                'power1': null, 'power2': null, 'protectionclass': null, 'temp_controlled': null,
                'temp_uncontrolled': null, 'connect_diameter': null, 'ec_technology': null,
                'hotair_upto120': null, 'duct_dimension': null,
                'create_at': null, 'update_at': null,
                'product_descriptions': [{ 'id': null, 'product_ref_no': null, 'product_version': null, 'language_id': null, 'description_short':null, 'description_long': null}],
                'product_prices':   [ { 'id': null, 'product_ref_no': null, 'product_version': null, 'pricelist_id': null, 'country_id': null, 'price': null, 'delivery': null }],
                'product_media': [ { 'id': null, 'product_ref_no': null, 'product_version': null, 'media_type': null, 'path': null, 'filename': null, 'country_id': null, 'f_download': null }],
                'delivery': null,
                  'listprice': null,
                'price': null,
                'accessories':[],
                'max_volumeflow': null,
                'max_pressure': null,
                'voltage1': null,
	              'voltage2': null,
                'phase': null,
                'frequency1': null,
	              'frequency2': null,
	              'ppz1': null,
                'ppz2': null,
                'max_dba': null,
                'flag_pipelineimage': null,
	              'flag_powerinfo': null,
                'ss_nr': null,
                'quantity': 1,
                'discount_1': null,
                'discount_2': null

              },
              mediaserver_url:'',//'https://globalstest.heliosventilatoren.de' ,
              selectedradio:[],





            allSelected: false,
            indeterminate: false




          }
		    },
        methods: {
          toggleAll(checked) {

           // this.selectedvalues['category'] = checked ? this.selectedvalues['category'].slice() : []
            if (checked) {
              this.selectedvalues['category']=[]
              this.uniquecats.forEach(function (c) {
                if(c!=null) this.selectedvalues['category'].push(c.id)
              }.bind(this))

            }
            else this.selectedvalues['category'] = []
          },






          setradio(radiokey,radiovalue){
            var prev_selectedradio=this.selectedradio[radiokey]
            if(prev_selectedradio==radiovalue) this.selectedvalues[radiokey]=null
            else {
              this.selectedvalues[radiokey]=radiovalue
              this.selectedradio[radiokey]=radiovalue
            }

          },
          setradiodimension(radiokey) {
/*
            var prev_selectedradio = this.selectedradio[radiokey]
            console.log('prev_selectedradio')
            console.log(prev_selectedradio)

            console.log('this.dimension.selection')
            console.log(this.dimension.selection)
            if (prev_selectedradio == radiokey) this.dimension.selection = null
            else {
              this.dimension.selection = radiokey;
            }
            this.selectedradio[radiokey] = this.dimension.selection */
           this.dimension.selection=radiokey;
           console.log(this.dimension.selection)

          },

         /* refreshSlide(){
           console.log('refreshSlide')
           console.log(this.$refs.wheel_diameter[0])
           this.$refs.wheel_diameter[0].$options.propsData.value=[0,200]

            this.$refs.wheel_diameter[0].refresh()
          }, */
          slideStop (key) {
                this.defaults_old[key]=this.selectedvalues[key]
               /* console.log('slideStarted:')
                console.log(key)
                console.log(this.defaults_old[key])
                console.log(this.selectedvalues[key])*/

          },
          customLabel (option) {
            return `${option.library} - ${option.language}`
          },
          select (option) {
            option.checked = !option.checked
          },
          onSelect (option) {
            //console.log("Added");
            let index = this.options.findIndex(item => item.library==option.library);
            this.options[index].checked = true;
            //console.log(option.library + "  Clicked!! " + option.checked);
          },

          onRemove (option) {
            console.log("Removed");
            let index = this.options.findIndex(item => item.library==option.library);
            this.options[index].checked = false;
            //console.log(option.library + "  Removed!! " + option.checked);
          },
          /*
           tt_format: function (val) {
            var retval
            if (Array.isArray(val)) {
              val.forEach(function (e, i) {
                val[i] = parseInt(e)
              });
              retval = val[0] + " : " + val[1];
            } else {
              retval = val;
            }
            console.log('retval:');
            console.log(retval);
            return retval
           },
           */
            unsetDimension:function(){
              var dim_selected = this.dimension.selection
              if (dim_selected) {
                var dimension_arr = Object.keys(this.selectedvalues).filter(function (x) {
                  return (x == 'wheel_diameter' || x == 'connect_diameter' || x == 'duct_dimension');
                })
                dimension_arr.forEach(function (d) {
                  console.log(d)
                  console.log(this.defaults_dimension[d])
                  this.defaults_old[d] = this.defaults_dimension[d];
                  this.selectedvalues[d] = this.defaults_dimension[d];
                }.bind(this))
              }
              this.dimension.selection=''








            },
           setFilterDefaults:function(){
              var arr = []
              var selectedvalues = {}

              var prodlist = this.$store.state.operatingpoint.resultlist_products


              this.dimension.selection=''



              this.filters.forEach(function (f) {
                    if (f.ffType == 'rangetick' || f.ffType == 'range') {
                      arr = prodlist.map(function (products) { return products[f.ffKey] });
                      var unique_arr = [...new Set(arr)]
                      var unique_filtered_arr = unique_arr.filter(function (el) {
                        return el != null;
                      });
                      unique_filtered_arr.sort(function (a, b) {
                        return a - b;
                      });
                      //var min=f.ffType == 'range'? 0 : Math.min(...unique_filtered_arr)
                      var min = f.ffType == 'range' && !isFinite(Math.min(...unique_filtered_arr)) ? 0 : Math.round(Math.min(...unique_filtered_arr))
                      var max= f.ffType == 'range'&& !isFinite(Math.max(...unique_filtered_arr)) ? 0 :Math.round(Math.max(...unique_filtered_arr))
                      /*selectedvalues[f.ffKey] = [0, max]*/
                      selectedvalues[f.ffKey] = [min, max]
                      this.defaults_old[f.ffKey] = selectedvalues[f.ffKey]
                      this.defaults_dimension[f.ffKey] = selectedvalues[f.ffKey]

                      //if(f.ffKey == 'wheel_diameter' || f.ffKey == 'connect_diameter')  selectedvalues[f.ffKey]=[]

                    }
                    else if(f.ffType == 'radiogroup') {
                      //selectedvalues[f.ffKey] = 'all'
                      selectedvalues[f.ffKey] = null
                    }
                    else if(f.ffType == 'radio' || f.ffType == 'select') {
                      //selectedvalues[f.ffKey] = 'all'
                      selectedvalues[f.ffKey] = null
                    }
                    else if(f.ffType == 'checkboxgroup') {
                      selectedvalues[f.ffKey] = []
                    }
                    else if (f.ffType == 'ddlbcheckboxgroup') {
                      arr = prodlist.map(function (products) { return products[f.ffKey] });
                      var unique_arr = [...new Set(arr)]
                      var unique_filtered_arr = unique_arr.filter(function (el) {
                        return el!=null && el!='';
                      });

                      unique_filtered_arr.sort(function (a, b) {
                        var a_arr = a.split('/');
                        var a_float=parseFloat(a_arr[0] + '.' + a_arr[1]);
                        var b_arr = b.split('/');
                        var b_float=parseFloat(b_arr[0] + '.' + b_arr[1]);

                        return parseFloat(a_float) - parseFloat(b_float);
                      });
                      selectedvalues[f.ffKey] = [];//unique_filtered_arr;
                      this.uniqueduct_dimension=unique_filtered_arr;
                      this.defaults_old[f.ffKey] = selectedvalues[f.ffKey]
                      this.defaults_dimension[f.ffKey] = selectedvalues[f.ffKey]
                    }
                    else  selectedvalues[f.ffKey]=null

              }.bind(this));

              var cats=[]
              for (let value of Object.values(this.uniquecats)) {
                 cats.push(value.id)
              }
              selectedvalues['category']= cats

              this.selectedvalues = selectedvalues

              return selectedvalues
           },
           opendetail(refno,version, flag_fan, execution,row){
            var query_params=this.query_params(refno,version, flag_fan, execution,row)

            if(this.user.auth){
              axios.post('/user/access/token', {navigation: 1}).then(response => {
                        Object.assign(query_params,  {access_token:response.data.access_token});
                    }).catch(function (error) {
                    });
             }
            let routeData = this.$router.resolve({ name: 'productdetail', query: query_params });
            window.open(routeData.href, '_blank');
          },
           query_params(refno,version, flag_fan, execution,row){
              var query_params = {
                ref_no: refno,
                version: version,
                execution: execution,
                language_id: this.$lang().locale  //navigator.language,
             }

              if(flag_fan==1 && this.search_flag == 'op' || (this.search_flag == 'showresult' && this.$store.state.operatingpoint.op.airflow > 0)) {



                Object.assign(query_params, {
                  airflowrate: this.$store.state.operatingpoint.op.airflow,
                  externalpressure: this.$store.state.operatingpoint.op.pressure,
                  airflow_unit: this.$store.state.operatingpoint.op.airflowunits,
                  externalpressure_unit: this.$store.state.operatingpoint.op.pressureunits,
                  externalpressuretyp: this.$store.state.operatingpoint.op.pressuretype,
                  airflowrate_dev: this.$store.state.operatingpoint.op.airflow_deviation,// airflowrate_dev1: this.$store.state.operatingpoint.op.airflow_deviation[0],airflowrate_dev2: this.$store.state.operatingpoint.op.airflow_deviation[1,
                  externalpressure_dev: this.$store.state.operatingpoint.op.pressure_deviation,
                  maxdba: this.$store.state.operatingpoint.op.maxdba,
                  airflowrate_is:row.volumeflow,
                  externalpressure_is:row.pressure,
                  wsoll_is:row.wsoll,
                  electricity:row.electricity ? row.electricity.toFixed(2):'',
                  elpower: row.elpower? row.elpower.toFixed(2):'',
                  rpm:row.rpm?row.rpm.toFixed(0):'',
                  sfp:row.sfp?row.sfp.toFixed(3):''

                });

                 // "op_is": { "airflowrate": 4876, "externalpressure": 352, "wsoll": 280, "electricity": 0, "elpower": 0, "rpm": 0, "sfp": 0 } },
                              }
              /* let routeData = this.$router.resolve({name: 'productdetail', query: query_params });
              window.open(routeData.href, '_blank'); */
              return query_params

           },
           async getFans(){

              var body = []
              var response
              this.resultlist = []
              this.categorydata = []



              if (this.search_flag == 'showresult') {
                this.resultlist = this.$store.state.operatingpoint.resultlist_products
                this.categorydata = this.$store.state.operatingpoint.resultlist_categories
              }
              else if (this.search_flag == 'op' || this.search_flag == 'directsearch' || this.search_flag=='apparea' || this.search_flag == 'cat') {
                document.getElementsByTagName("body")[0].classList.add("is-loading");
                if (this.search_flag == 'op' || this.search_flag == 'cat' ) {

                  body.push({
                    airflowrate: this.$store.state.operatingpoint.op.airflow,
                    externalpressure: this.$store.state.operatingpoint.op.pressure,
                    airflow_unit: this.$store.state.operatingpoint.op.airflowunits,
                    externalpressure_unit: this.$store.state.operatingpoint.op.pressureunits,
                    externalpressuretyp: this.$store.state.operatingpoint.op.pressuretype,
                    airflowrate_dev: this.$store.state.operatingpoint.op.airflow_deviation,
                    externalpressure_dev: this.$store.state.operatingpoint.op.pressure_deviation,
                    categories: this.$store.state.operatingpoint.selectedCategories,
                    language_id: this.$lang().locale,  //navigator.language,
                    maxdba: this.$store.state.operatingpoint.op.maxdba

                  })
                  response = await operatingpointApi.getFans(body);
                }
                else if (this.search_flag == 'directsearch') {


                  body.push({
                    searchkeyword: this.$store.state.operatingpoint.search.keyword,
                    searcharchive: this.$store.state.operatingpoint.search.archive,
                    language_id: this.$lang().locale  //navigator.language,
                  })

                  response = await operatingpointApi.getFansBySearch(body);

                }
                else if (this.search_flag == 'apparea') {

                  body.push({

                    categories: this.$store.state.operatingpoint.selectedCategories,
                    language_id: this.$lang().locale,  //navigator.language,


                  })


                  response = await operatingpointApi.getFansByCategory(body);

                }
                if (response.success != false) {
                    var show_price=true;
                    if (!this.user.auth || this.user.countries_price == '' || (this.user.auth && this.user.countries_price != this.selectedlocale.country) ) {
                        show_price=false
                    }



                  response.products.forEach(function (item) {
                    if (item.product_prices.length != 0 && show_price) {
                      item.delivery = item.product_prices[0].delivery
                      item.price = parseFloat(item.product_prices[0].price).toFixed(2)
                      item.listprice = parseFloat(item.product_prices[0].price).toFixed(2)
                    }
                    else {
                      item.delivery = 'A'
                      item.price = 0
                      item.listprice=0
                    }
                    //ToDo hier st description and image
                    if (item.product_media.length != 0) {
                      item.image = item.product_media.filter(item => item.media_type == 'image').map(function (image) { return image.path + image.filename })[0]
                    }
                    if (item.product_descriptions.length != 0) {
                      item.description_short = item.product_descriptions.map(function (desc) { return desc.description_short })[0]
                      item.description_long = item.product_descriptions.map(function (desc) { return desc.description_long })[0]
                    }
                     item.quantity = 1 // 2023-08-03 dazu gekommen (auskomm in accssories.vue) wegen shoppingcart 'tote Zeile' keine reaktion auf änderung by anzahl,rabatt wenn artikel über modalen dialog hizugefügt wurde
                  });
                  this.resultlist = response.products
                  this.categorydata = response.categorydata
                }
                else {
                  this.resultlist = []
                  this.categorydata = []
                }
                this.$store.commit('operatingpoint/updateResultListProducts', this.resultlist);
                this.$store.commit('operatingpoint/updateResultListCategories', this.categorydata);
                this.$store.commit('operatingpoint/updatesearch', { keyword: '', archive: 0 });
               // this.$store.commit('operatingpoint/updateactionarealoaded', '1');

             }
             else {  //for felderer:
                  this.resultlist = []
                  this.categorydata = []
                  this.$store.commit('operatingpoint/updateResultListProducts', this.resultlist);
                  this.$store.commit('operatingpoint/updateResultListCategories', this.categorydata);
                  this.$store.commit('operatingpoint/updatesearch', { keyword: '', archive: 0 });
             }
             if (this.search_flag == 'cat') {
                this.$store.commit('operatingpoint/updateSelectedCategories', [])
                this.$store.commit('operatingpoint/setDescSelectedCategories', [])
                this.$store.commit('operatingpoint/updateSelectedTmpCategories', [])
              }
             document.getElementsByTagName("body")[0].classList.remove("is-loading");

              //document.getElementById("autosuggest__input").value=''
            },
            setFieldLabels: function(value){
              var array =[];
              var sortable=true

              for(var i = 0; i < value.length; i++){
                if(value[i].key=='price') {
                  array.push({
                    key: value[i].key, label: this.__(value[i].label),  sortable: sortable, sortByFormatted: sortable,_showDetails:true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {
                      var price = parseFloat(value)

                      if (!this.user.auth) return this.__('lang.message.loginrequired');
                      else if (this.user.countries_price == '') return this.__('lang.global.onrequest'); //+' PreisLand unbekannt';
                        /*  else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest'); //+' fremdes Land'; */
                      else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) return this.__('lang.global.onrequest'); //+' fremdes Land';
                      else return price >0 ? price.toFixed(0): this.__('lang.global.onrequest');
                    }
                  })
                }
                else if(value[i].key=='volumeflow') {
                  var selected_airflow_unit =  this.search_flag=='op'?this.$store.state.operatingpoint.op.airflowunits:1
                  var arr = this.$store.state.operatingpoint.op.airflowunits_options.filter(item => item.value == selected_airflow_unit)

                  var to_fixed_arr_airflowunits = this.$store.state.operatingpoint.op.units.filter(u => u.unit_types_id == 1 && u.id == selected_airflow_unit).map(unitformat => unitformat.format_str)
                  var to_fixed = to_fixed_arr_airflowunits ? parseInt(to_fixed_arr_airflowunits[0]):0


                  array.push({
                    key: value[i].key, label: this.__(arr[0].text),  sortable: sortable, sortByFormatted: sortable,_showDetails:true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {

                      return parseFloat(value).toFixed(to_fixed);
                    }
                  })
                }
                else if(value[i].key=='pressure') {
                  var selected_pressure_unit = this.$store.state.operatingpoint.op.pressureunits
                  var headersort = this.search_flag=='op'? true :false
                  var arr = this.$store.state.operatingpoint.op.pressureunits_options.filter(item => item.value == selected_pressure_unit)

                  var to_fixed_arr_pressureunits = this.$store.state.operatingpoint.op.units.filter(u => u.unit_types_id == 2 && u.id == selected_pressure_unit).map(unitformat => unitformat.format_str)
                  var to_fixed = to_fixed_arr_pressureunits ? parseInt(to_fixed_arr_pressureunits[0]) : 0


/*

                  console.log('this.$store.state.operatingpoint.op:')
                  console.log(this.$store.state.operatingpoint.op)
                  console.log('selected_pressure_unit:')
                  console.log(selected_pressure_unit) */

                  array.push({
                    key: value[i].key, label: this.__(arr[0].text), sortable: headersort, sortByFormatted: headersort, _showDetails:true, thClass: 'small border-bottom', headerSort:headersort,
                    formatter: (value, key, item) => {
                      return parseFloat(value).toFixed(to_fixed);
                    }
                  })
                }
                else if(value[i].key=='elpower') {
                  array.push({
                    key: value[i].key, label: this.__(value[i].label),  sortable: sortable, sortByFormatted: sortable,_showDetails:true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {
                      return +(Math.round(parseFloat(value/1000) + "e+2")  + "e-2");
                    }
                  })
                }
                else if(value[i].key=='delivery') {
                  array.push({
                    key: value[i].key, label: this.__(value[i].label),sortable: sortable, sortByFormatted: sortable, _showDetails:true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {
                      if(isNaN(value)) return this.__('lang.delivery_' + value.toLowerCase())
                      else return value +' '+this.__('lang.units.week_short')

                    }
                  })
                }

                else {
                  if(value[i].key=='shoppingcart' || value[i].key== 'info') sortable=false
                  array.push({
                    key: value[i].key, label: this.__(value[i].label), sortable: sortable, sortByFormatted: sortable, _showDetails:true, thClass: 'small border-bottom',
                    formatter: (value, key, item) => {
                        if(typeof value == "number") return Math.round(value);
                        else return value;
                      }
                    })
                   }

                //console.log(value[i]);
              }


            return array;
          },
          setCartItem(row,index){
            this.productlist_item = row
           /* console.log('setCartItem: this.productlist_item ')
            console.log(this.productlist_item)*/
            var query_params = this.query_params(row.ref_no, row.version, 1, row.execution,row)

            if (!this.user.auth || this.user.countries_price == '' || (this.user.auth && this.user.countries_price != this.selectedlocale.country) ) {
                this.productlist_item.listprice = 0
                this.productlist_item.price = 0
            }
            var op_is = {}
            if (this.productlist_item.volumeflow) {
              Object.assign(op_is, {
                airflowrate: this.productlist_item.volumeflow,
                externalpressure: this.productlist_item.pressure,
                wsoll: this.productlist_item.wsoll,
                electricity: this.productlist_item.electricity??'',
                elpower: this.productlist_item.elpower??'',
                rpm: this.productlist_item.rpm??'',
                sfp: this.productlist_item.sfp??''
              });
            }
            Object.assign(this.productlist_item, { index: index }, { wg: this.productlist_item.prodgroup }, {productmarker:0},{ op: { op_must: query_params, op_is: op_is } })
            this.getProductAccessories(row.ref_no, row.version)
          },
          async getProductAccessories(ref_no, version){
              this.$refs.add_from_productlist.getProductAccessories(ref_no, version)
          },
          resetdimension: function(){
            var dim_selected
            dim_selected =this.dimension.selection
            //var prodlist = this.$store.state.operatingpoint.resultlist_products
            //var arr
            //var mySlider = this.$refs.wheel_diameter

            if (dim_selected) {
               var dimension_arr = Object.keys(this.selectedvalues).filter(function (x) {
                  return (x=='wheel_diameter'|| x=='connect_diameter' || x=='duct_dimension');
                })
                dimension_arr.forEach(function (d) {
                  if (d!= dim_selected){

                      /*defaults:
                      arr = prodlist.map(function (products) {return products[d] });
                      var unique_arr = [...new Set(arr)]
                      var unique_filtered_arr = unique_arr.filter(function (el) {
                        return el != null;
                      });
                      if(unique_filtered_arr.length){

                        unique_filtered_arr.sort(function (a, b) {
                          var a_arr = a.split('/');
                          var a_float=parseFloat(a_arr[0] + '.' + a_arr[1]);
                          var b_arr = b.split('/');
                          var b_float=parseFloat(b_arr[0] + '.' + b_arr[1]);

                          return parseFloat(a_float) - parseFloat(b_float);
                        });
                        this.selectedvalues[d] = unique_filtered_arr;

                      }
                      else this.selectedvalues[d] = [];
                    */
                    this.selectedvalues[d] = this.defaults_dimension[d]//[];

                    //if(dim_selected!='wheel_diameter' &&  dim_selected!='duct_dimension') mySlider[0].disable()

                  }
                  else {
                    this.selectedvalues[d] = this.defaults_old[d];
                    /* console.log('resetdimensiongsgsg:')
                    console.log(this.selectedvalues[d])
                    var mySlider = this.$refs.wheel_diameter
                    console.log(mySlider[0])
                    if(dim_selected=='wheel_diameter'){
                      mySlider[0].enable()
                      mySlider[0].refresh({ useCurrentValue: true })
                    }  */
                  }
                }.bind(this))
            }
          },
          loadFans: function(){
            var prodlist_filtered=[]
            var prodlist = this.$store.state.operatingpoint.resultlist_products

            var filters= this.filters;
            var ff={}

            var dim_selected =this.dimension.selection

            filters.forEach(function (f) {
                ff[f.ffKey] = f.ffType
                return ff
            });
            if(dim_selected!='')   console.log(dim_selected)




            prodlist_filtered = prodlist.filter(products => {
              return Object.keys(this.selectedvalues).every(propertyName => {
                var cond
                var val=[]
                var val_arr=[]

                if(products['flag_fan']==2 || products['product_categories'].length==0) cond =true
                else {

                    if(propertyName=='category'){
                      cond = false
                      if (products['product_categories'].length > 0) {
                        this.selectedvalues[propertyName].forEach(function (cat) {
                            var i= products['product_categories'].findIndex(x => (x.category_id==cat))
                            if (!(i <= -1)) cond = true
                        })
                      }
                      else  cond = false //true
                    }
                    else if(ff[propertyName] =='ddlbcheckboxgroup' ){
                        if(dim_selected && dim_selected!='' && dim_selected==propertyName)  cond = (this.selectedvalues[propertyName]==null || this.selectedvalues[propertyName]==false) ? products[propertyName]==products[propertyName]: this.selectedvalues[propertyName].includes(products[propertyName])
                        else cond=true
                    }
                    else if (this.selectedvalues[propertyName] && (products[propertyName] || ((ff[propertyName] == 'range' || ff[propertyName] == 'rangetick') && parseFloat(products[propertyName]) >= 0))) {
                        if(ff[propertyName] =='radiogroup'){
                          var prodvalue_arr=products[propertyName].split(";");
                          cond = (this.selectedvalues[propertyName]==null || this.selectedvalues[propertyName]==false) ? products[propertyName]==products[propertyName]:prodvalue_arr.includes(this.selectedvalues[propertyName])
                        }
                        else if(ff[propertyName] =='checkbox' || ff[propertyName] =='radio' || ff[propertyName] =='select')
                          cond = (this.selectedvalues[propertyName]==null || this.selectedvalues[propertyName]==false) ? products[propertyName]==products[propertyName]:products[propertyName] == this.selectedvalues[propertyName]
                        else if(ff[propertyName] =='checkboxgroup') {
                          cond = (this.selectedvalues[propertyName]==null || this.selectedvalues[propertyName]==false) ? products[propertyName]==products[propertyName]: this.selectedvalues[propertyName].includes(products[propertyName])
                        }
                        else if (ff[propertyName] == 'range' || ff[propertyName] == 'rangetick'){

                         //--if(dim_selected && dim_selected!='' && this.dimension.selection==propertyName){
                            if (Array.isArray(this.selectedvalues[propertyName])) {
                              var val_arr = this.selectedvalues[propertyName].filter(function (el) {
                                return isFinite(el) && el!=null && el != 'undefined'; // false if the value is + infinity, -infinity, or NaN(Not - a - Number), otherwise it returns true.
                              }).sort(function (a, b) {
                                return a - b;
                              });
                              val_arr.forEach(function (e, i) {
                                val[i] = parseFloat(e);
                              });
                              if(isFinite(val[0]) && isFinite(val[1]) ) cond = products[propertyName] >= val[0] && products[propertyName] <= val[1]
                              else cond = true
                            } else {
                                cond = products[propertyName] <= this.selectedvalues[propertyName]
                          }

                          //--}
                          //--else cond=true
                        }
                        else cond = products[propertyName] <= this.selectedvalues[propertyName]
                    }

                    else if((ff[propertyName] ==='checkboxgroup' || (ff[propertyName] =='ddlbcheckboxgroup' && this.dimension.selection==propertyName)) && Array.isArray(this.selectedvalues[propertyName] ) && this.selectedvalues[propertyName].length && (products[propertyName]==null || products[propertyName]=='')){
                      cond=false
                    }
                    else if((ff[propertyName] ==='radio' || ff[propertyName] =='checkbox' || ff[propertyName] ==='radiogroup') && this.selectedvalues[propertyName] && (products[propertyName]==null || products[propertyName]==0)){
                      cond=false
                    }
                   /*  else if((dim_selected && dim_selected!='' && this.dimension.selection==propertyName) &&
                      (propertyName=='wheel_diameter' || propertyName=='connect_diameter' ) &&
                      (ff[propertyName] == 'range' || ff[propertyName] == 'rangetick') && Array.isArray(this.selectedvalues[propertyName] ) && this.selectedvalues[propertyName].length && isFinite(this.selectedvalues[propertyName][0]) && isFinite(this.selectedvalues[propertyName][1]) && products[propertyName]==null){
                      cond=false
                    }
                    else if((ff[propertyName] == 'range' || ff[propertyName] == 'rangetick') && Array.isArray(this.selectedvalues[propertyName] ) && this.selectedvalues[propertyName].length && isFinite(this.selectedvalues[propertyName][0]) && isFinite(this.selectedvalues[propertyName][1]) && products[propertyName]==null){

                      cond=false
                    }  */
                    else if (ff[propertyName] == 'range' || ff[propertyName] == 'rangetick') {
                        if(dim_selected && dim_selected!='' && this.dimension.selection==propertyName && Array.isArray(this.selectedvalues[propertyName] ) && this.selectedvalues[propertyName].length && isFinite(this.selectedvalues[propertyName][0]) && isFinite(this.selectedvalues[propertyName][1]) && products[propertyName]==null){
                            cond=false
                        }
                        else{
                          cond=true
                        }
                    }
                    else cond=true
                }
                return cond
              })
            });
            /*console.log('loadFans selectedvalues:')
            console.log(this.selectedvalues)
            console.log('prodlist_filtered:');
            console.log(prodlist_filtered);*/
            this.resultlist = prodlist_filtered;
          },
          sortOnTableColumn(a, b, key, sortDesc) {
            let result = 0;
             //console.log('sort'+key)
            // If both compared fields are native numbers
            //&& typeof a[key] === 'number' && typeof b[key] === 'number'
            if (key === 'ref_no') {
              if (a[key] && b[key]) return parseInt(a[key]) < parseInt(b[key]) ? -1 : parseInt(a[key]) > parseInt(b[key]) ? 1 : 0;
            }
            else if (key === 'volumeflow') {
              if (a[key] && b[key]) return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
              else return a['max_volumeflow'] < b['max_volumeflow'] ? -1 : a['max_volumeflow'] > b['max_volumeflow'] ? 1 : 0;
            }
            else if (key === 'elpower') {
              if (a[key] && b[key]) return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
              else {
                var max_a = Math.max(a['power1'], a['power2']);
                var max_b = Math.max(b['power1'], b['power2']);
                return max_a < max_b ? -1 : max_a > max_b ? 1 : 0;
              }
            }
            else if (key === 'rpm') {
              if (a[key] && b[key]) return parseFloat(a[key]) < parseFloat(b[key]) ? -1 : parseFloat(a[key]) > parseFloat(b[key]) ? 1 : 0;
              else return parseFloat(a['max_rpm']) < parseFloat(b['max_rpm']) ? -1 : parseFloat(a['max_rpm']) > parseFloat(b['max_rpm']) ? 1 : 0;
            }
            else if (key === 'type') {
              return a[key].toString().localeCompare(b[key].toString())
            }
            else if (key === 'price' || key === 'max_dba') {
              return parseInt(a[key]) < parseInt(b[key]) ? -1 : parseInt(a[key]) > parseInt(b[key]) ? 1 : 0;
            }
            else if (key === 'dimension') {

              var a_float=0, b_float=0
              if (a['duct_dimension'] && a['duct_dimension'] != 'NULL') {
                var a_arr = a['duct_dimension'].split('/');
                var a_float = parseFloat(a_arr[0] + '.' + a_arr[1]);
              }
              if (b['duct_dimension'] && b['duct_dimension'] != 'NULL') {
                var b_arr = b['duct_dimension'].split('/');
                b_float = parseFloat(b_arr[0] + '.' + b_arr[1]);
              }


              var row1 = {
                connect_diameter: a['connect_diameter'],
                /*wheel_diameter: a['wheel_diameter'],*/
                duct_dimension: a_float
              }
              var row2 = {
                connect_diameter: b['connect_diameter'],
               /* wheel_diameter: b['wheel_diameter'],*/
                duct_dimension:b_float
              }

              const max_a = Math.max.apply(null, Object.values(row1));
              const max_b = Math.max.apply(null, Object.values(row2));

              return max_a < max_b ? -1 : max_a > max_b ? 1 : 0;

            }
            else{
              return this.toString(a).localeCompare(toString(b), undefined, {
                numeric: true,
              })

            }
            return false;
          },
          toString(value) {
            if (value === null || typeof value === 'undefined') {
              return ''
            } else if (value instanceof Object) {
              return Object.keys(value)
                .sort()
                .map(key => toString(value[key]))
                .join(' ')
            } else {
              return String(value)
            }
          },
          /* doSomethingOnHidden(){
            alert('hidden')
          } */
         /*  clearSession() {
            this.$root.$emit("clearSession",{
              from:"ProductlistTable"
            })

          } */
          gotostartpage() {
            this.$root.$emit("gotostartpage",{
              from:"ProductlistTable"
            })

          },
          getLongDesc(desc) {
            var str = ''
            if (desc != null) str = desc.replace(/(<([^>]+)>)/ig, '');
            return str.length > 255 ? str.substring(0, 255) + '...' : str;
          },



      },
      mounted () {
        //$(this.$refs.vuemodal).on("hidden.bs.modal", this.doSomethingOnHidden)
      },
      created() {
        document.getElementsByTagName("body")[0].classList.add("is-loading");

        this.getFans();

       /*  EventBus.$on('loadprodlist', () => {
                this.getFans()
        }) // from ProductSearch */


      },
      watch: {
        selectedvalues:{
          handler: function (newValue) {

            // Handle changes in individual flavour checkboxes
           /* console.log('newValue')
            console.log(newValue.category)
            console.log('catlen:')
            console.log(this.selectedvalues['category'])
*/
            if (newValue.category.filter(e => e != null && e!= false ).length === 0) {
              this.indeterminate = true
              this.allSelected = false
            } else if (newValue.category.filter(e => e != null && e != false).length === this.selectedvalues['category'].filter(e => e != null && e != false).length) {
              this.indeterminate = false
              this.allSelected = true
            } else {
              this.indeterminate = true
              this.allSelected = false
            }

            this.loadFans();
          },
          deep:true //You need to set deep to true when watching an array or object so that Vue knows that it should watch the nested data for changes.
        },
        'dimension.selection': {
          handler(newVal, oldVal){  // here having access to the new and old value

            if(oldVal!='') this.dimensiondisabled[oldVal]=true
            this.dimensiondisabled[newVal]=false
            this.resetdimension();
            //this.refreshSlide();

            /*
            console.log('watch dimension.selection oldVal');
            console.log(oldVal);
            console.log(newVal); */
            this.loadFans();
          },
          deep: true,
          immediate: true //  Also very important the immediate in case you need it, the callback will be called immediately after the start of the observation

        },




      }

    }
</script>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->
<style>
[id^="ddlb-cb"] {
                padding: 2px 0;
            }

.range-slider-maxvalue {
    display: inline-block;
    position: absolute;
    top: 20px;
    right:12px;
    font-size: x-small;
}
.range-slider-minvalue{
    display: inline-block;
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: x-small;
}
.slider-disabled .slider-selection {
    background-color: #c7c7c7;
}
#cat_ddlb a.nav-link {
  display: block;
  padding: 0 0;
}
#cat_ddlb a.nav-link:hover {
 color: #333;
}
ul.dropdown-menu {
  margin: .5rem -0.75rem 0 !important;
  overflow: auto;
  height: 250px;
  width: 100%;
}

  /*
  .tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 0;
    margin-top: 0px;
    font-family: "Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 0.875rem;
    word-wrap: break-word;
    opacity: 1 !important;
  }

  .top .tooltip-arrow::before, .auto[x-placement^="top"] .tooltip-arrow::before {
    top: 0;
    border-width: .4rem .4rem 0;
    border-top-color: #000;
  }
  .tooltip .tooltip-arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
        border-top-color: transparent;
    border-style: solid;
}
.slider .tooltip.top .tooltip-arrow, .slider .tooltip.bottom .tooltip-arrow {
    left: -0.4rem;
}
.top .tooltip-arrow, .auto[x-placement^="top"] .tooltip-arrow {
    bottom: 0;
}
.tooltip .tooltip-arrow {
    position: absolute;
    display: block;
    width: .8rem;
    height: .4rem;
} */
.b-popover{
  border:none;
}
.popover.quickview .popover-body {

  background-color: #e8e8e8;
  max-height: 45vh;
  width: 35vw;
  border-radius: 0.375rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popover-body {
  padding: .5rem .75rem;
  color: #212529;
}

.popover.quickview .media {
  align-items: center;
}
.media {
  display: flex;
}

.media-body {
  flex: 1;
}


.bs-popover-auto[x-placement^="top"] > .arrow, .bs-popover-top > .arrow {
  bottom: calc(-.5rem - 1px);
}

.popover .arrow {
  width: 1rem;
  height: .5rem;
  margin: 0 .3rem;
}
.popover, .popover .arrow {
  position: absolute;
  display: block;
}

/* arrrow color
.popover.quickview .arrow {

   background-color:#e8e8e8 !important;
}
*/




.popover.quickview[x-placement=right] .arrow:after {
    border-right-color: #e8e8e8 !important;
}

.popover.quickview[x-placement=top] .arrow:after {
  border-top-color: #e8e8e8;
}

.popover.quickview[x-placement=bottom] .arrow:after {
  border-bottom-color: #e8e8e8;
}

.popover.quickview[x-placement=left] .arrow:after {
  border-left-color: #e8e8e8;
}
.popover.quickview .arrow::before {
    border: none !important;
}


</style>
